import React from 'react';
import { IconPropType } from '../../../../Interfaces/IconPropType';
import { neutral } from '../../../../style/colors';
export const History = (props: IconPropType) => {
  const { width, height, color, style, onClick } = props;
  return (
    <svg
      onClick={onClick ? () => onClick() : () => {}}
      style={style}
      width={width ? width : height ? height * (15 / 14) : 15}
      height={height ? height : width ? width * (14 / 15) : 14}
      viewBox="0 0 15 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Screens"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Infopanelet---Standard"
          transform="translate(-1352.000000, -222.000000)"
          fill={color ? color : neutral[600]}
          fillRule="nonzero"
        >
          <g id="history-solid" transform="translate(1352.544189, 222.056393)">
            <path
              d="M13.6546449,6.81440519 C13.661598,10.5760364 10.593903,13.6519627 6.83227184,13.6546073 C5.20761827,13.6557618 3.71529902,13.0894248 2.54256976,12.142933 C2.23762546,11.8968193 2.21483103,11.439802 2.491943,11.16269 L2.8021179,10.8525151 C3.03911939,10.6155137 3.41748486,10.5895809 3.68006126,10.7978966 C4.54407468,11.4835189 5.63751897,11.8927449 6.82731653,11.8927449 C9.62720454,11.8927449 11.8927449,9.62676407 11.8927449,6.82731653 C11.8927449,4.02742851 9.62676407,1.76188814 6.82731653,1.76188814 C5.48349141,1.76188814 4.26297093,2.28409526 3.35672725,3.13649124 L4.7539596,4.53372359 C5.03145698,4.81122097 4.83492387,5.28566441 4.44251835,5.28566441 L0.440472034,5.28566441 C0.197193824,5.28566441 0,5.08847058 0,4.84519237 L0,0.843146061 C0,0.450740538 0.47444344,0.254207423 0.751940821,0.531677274 L2.1111274,1.89086385 C3.33682342,0.719511067 4.99803617,0 6.82731653,0 C10.5936277,0 13.6476681,3.04971824 13.6546449,6.81440519 Z M8.67421576,8.98328948 L8.94463806,8.63559187 C9.16867315,8.34755069 9.11678004,7.93243333 8.82873886,7.70842577 L7.70826059,6.83692432 L7.70826059,3.96424831 C7.70826059,3.59934475 7.41245609,3.30354025 7.04755254,3.30354025 L6.60708051,3.30354025 C6.24217696,3.30354025 5.94637246,3.59934475 5.94637246,3.96424831 L5.94637246,7.6986528 L7.74704966,9.09918869 C8.03509084,9.32319625 8.45018068,9.27133067 8.67421576,8.98328948 L8.67421576,8.98328948 Z"
              id="Shape"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default History;
